const STOP_WORDS = new Set([
  "del",
  "las",
  "los",
  "spa",
  "ltda",
  "limitada",
  "sociedad",
  "cia",
]);

export const normalizeText = (value: string): string =>
  value.normalize("NFD").replace(/\p{M}/gu, "").toLowerCase().trim();

export const normalizeCode = (value: string): string =>
  normalizeText(value).replace(/[^a-z0-9]/g, "");

export const normalizePhone = (value: string): string =>
  value.replace(/\D/g, "").slice(-8);

export const tokenize = (value: string): string[] =>
  normalizeText(value)
    .split(/[^a-z0-9ñ]+/)
    .filter((token) => token.length >= 3 && !STOP_WORDS.has(token));

const levenshtein = (a: string, b: string): number => {
  const prev = Array.from({ length: b.length + 1 }, (_, i) => i);
  for (let i = 1; i <= a.length; i++) {
    let diagonal = prev[0];
    prev[0] = i;
    for (let j = 1; j <= b.length; j++) {
      const temp = prev[j];
      prev[j] = Math.min(
        prev[j] + 1,
        prev[j - 1] + 1,
        diagonal + (a[i - 1] === b[j - 1] ? 0 : 1),
      );
      diagonal = temp;
    }
  }
  return prev[b.length];
};

const tokensMatch = (a: string, b: string): boolean => {
  if (a === b) return true;
  const [short, long] = a.length <= b.length ? [a, b] : [b, a];
  if (long.startsWith(short)) return true;
  return short.length >= 5 && levenshtein(a, b) <= 1;
};

export const isSimilarName = (query: string, candidate: string): boolean => {
  const queryTokens = tokenize(query);
  const candidateTokens = tokenize(candidate);
  if (!queryTokens.length || !candidateTokens.length) return false;

  const matched = queryTokens.filter((token) =>
    candidateTokens.some((other) => tokensMatch(token, other)),
  ).length;

  return matched >= Math.min(2, queryTokens.length, candidateTokens.length);
};

export const searchTermsFor = (value: string, max = 3): string[] =>
  [...new Set(tokenize(value))]
    .sort((a, b) => b.length - a.length)
    .slice(0, max);
